import { Typography } from '@pmi.web/react-common';
import { useTranslation } from 'react-i18next';

import { HelpSlide } from '../HelpSlide';

export function SlideEarn() {
  const { t } = useTranslation();

  return (
    <HelpSlide>
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="4.74712"
          y="4.75261"
          width="52.4904"
          height="52.4904"
          rx="26.2452"
          stroke="#061423"
          strokeWidth="3.49936"
        />
        <path
          d="M31.172 29.4461L31.1714 29.4459C29.9151 29.155 28.8521 28.8731 28.1012 28.4151C27.7309 28.1892 27.4469 27.9263 27.2544 27.6074C27.0628 27.2899 26.9526 26.9017 26.9526 26.4097C26.9526 25.506 27.334 24.7934 27.9991 24.2991C28.6712 23.7995 29.6493 23.5123 30.8461 23.5117C32.4998 23.5633 34.0274 24.0708 35.5913 25.1989L35.6024 25.2069L35.6143 25.2136C35.7213 25.2748 35.8577 25.3331 36.007 25.3188C36.1742 25.3029 36.2949 25.2041 36.3767 25.0824L37.2171 23.8743L37.2171 23.8744L37.22 23.8701C37.2866 23.7701 37.3496 23.6364 37.3344 23.4841C37.3182 23.322 37.2212 23.2035 37.104 23.1229C35.4141 21.8183 33.9268 21.1637 32.1606 20.9677V19.3342C32.1606 19.1892 32.1241 19.0329 32.006 18.9148C31.8878 18.7967 31.7316 18.7602 31.5866 18.7602H30.3503C30.2094 18.7602 30.0598 18.8017 29.9482 18.9208C29.839 19.0372 29.8027 19.1891 29.8027 19.3342V20.9934C28.308 21.1554 26.9543 21.6428 25.9546 22.4945C24.8952 23.397 24.2527 24.6931 24.2527 26.3834C24.2527 28.2662 25.098 29.5178 26.305 30.372C27.4964 31.2153 29.0385 31.6711 30.4494 32.0008L30.4494 32.0008L30.4533 32.0017C31.6744 32.2671 32.8362 32.5234 33.697 33.0009C34.1222 33.2368 34.461 33.5202 34.6941 33.874C34.9257 34.2253 35.0633 34.6614 35.0633 35.2212C35.0633 36.2307 34.5947 36.9622 33.8541 37.4519C33.1036 37.9482 32.0671 38.1979 30.9571 38.1982C29.1929 38.1725 27.6697 37.4957 25.9634 36.1259C25.8414 36.0249 25.6936 35.9689 25.5313 35.9998C25.3857 36.0276 25.2745 36.1178 25.1964 36.1959L25.1815 36.2108L25.1692 36.228L24.3046 37.4331C24.2235 37.5368 24.1677 37.6712 24.1815 37.8223C24.1955 37.9768 24.2784 38.1069 24.3954 38.2053C26.1208 39.7242 27.7912 40.5641 29.8027 40.7706V42.5598C29.8027 42.7049 29.839 42.8568 29.9482 42.9732C30.0598 43.0923 30.2094 43.1337 30.3503 43.1337H31.5866C31.7316 43.1337 31.8878 43.0973 32.006 42.9792C32.1241 42.861 32.1606 42.7048 32.1606 42.5598V40.7411C33.6829 40.5657 35.0564 40.0527 36.0688 39.1817C37.1395 38.2604 37.7894 36.9522 37.7894 35.2738C37.7894 33.1668 36.8642 31.8654 35.5577 31.0164C34.2738 30.182 32.6233 29.786 31.172 29.4461Z"
          fill="#061423"
          stroke="#061423"
          strokeWidth="0.516667"
        />
      </svg>
      <div
        style={{
          marginTop: 'var(--pmi-spacing-md)',
        }}
      >
        <Typography variant="h1">{t('Earn')}</Typography>
      </div>
      <div style={{ gap: 'var(--pmi-spacing-xs)' }}>
        <Typography variant="p">
          {t(
            'Sell your baskets within 7 days and receive instant commissions, if you have Direct Cash enabled in your country.',
          )}
        </Typography>
      </div>
    </HelpSlide>
  );
}
